import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_USERS_IGNORED').plugin(axiosPlugin, {template: "array"});

let fetchUsersIgnoredAction = redux.fetchActionGet();

export const fetchUsersIgnored = (query = {}) => fetchUsersIgnoredAction(`/users/me/users-ignored?${queryString.stringify(query)}`);
export const resetUsersIgnored = () => redux.actions.reset();

export const usersIgnored = redux.reducer();
